import { constants } from "@/constants";

const POST_PURCHASE_ORDER_TYPES = new Set(["crosssell", "upsell"]);
const ONE_CLICK_ORDER_METHODS = new Set(["oneclick", "fallback_oneclick"]);

function normalizeConfirmationStep(step) {
  const parsed = Number(step);
  return Number.isFinite(parsed) ? parsed : 0;
}

function isSepaPaymentType(paymentType) {
  return (
    String(paymentType || "").toLowerCase() === constants.PAYMENT_METHOD_SEPA
  );
}

function isInitialOrderType(orderType) {
  return !orderType || orderType === "initial";
}

/** Commande one-click SEPA éligible à l'annulation sur la confirmation initiale. */
export function isOneClickSepaCancellableOrder(order, step = 0) {
  if (!order) {
    return false;
  }

  if (normalizeConfirmationStep(step) !== 0) {
    return false;
  }

  if (!isInitialOrderType(order.orderType)) {
    return false;
  }

  if (!isSepaPaymentType(order.paymentType)) {
    return false;
  }

  return ONE_CLICK_ORDER_METHODS.has(order.orderMethod);
}

export function isPostPurchaseConfirmationOrder(order) {
  if (!order) {
    return false;
  }

  return POST_PURCHASE_ORDER_TYPES.has(order.orderType);
}

const CONFIRMATION_CAMPAIGN_STATS_STEPS = {
  upsell: "confirmation_upsell",
  crosssell: "confirmation_cross-sell",
};

/** Campaign Stats V3 step for order page confirmation from order.orderType. */
export function resolveConfirmationCampaignStatsStep(orderType) {
  return CONFIRMATION_CAMPAIGN_STATS_STEPS[orderType] || "confirmation_initial";
}

/**
 * Contexte confirmation où l'on affiche le lien d'annulation et masque
 * cadeaux / accès plateforme.
 */
export function shouldApplyConfirmationCancelPolicy(order, step = 0) {
  if (!order) {
    return false;
  }

  if (isPostPurchaseConfirmationOrder(order)) {
    return true;
  }

  return isOneClickSepaCancellableOrder(order, step);
}

/** Masque cadeaux / redirects uniquement pour one-click SEPA initial (lien d'annulation). */
export function shouldHideConfirmationGiftsForCancelPolicy(order, step = 0) {
  return isOneClickSepaCancellableOrder(order, step);
}
